import { render, staticRenderFns } from "./EmrColumnManageList.vue?vue&type=template&id=747cd41b&scoped=true&"
import script from "./EmrColumnManageList.vue?vue&type=script&lang=js&"
export * from "./EmrColumnManageList.vue?vue&type=script&lang=js&"
import style0 from "./EmrColumnManageList.vue?vue&type=style&index=0&id=747cd41b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747cd41b",
  null
  
)

export default component.exports